import { render, staticRenderFns } from "./RegisteredAddressesTable.vue?vue&type=template&id=05fca248"
import script from "./RegisteredAddressesTable.vue?vue&type=script&lang=js"
export * from "./RegisteredAddressesTable.vue?vue&type=script&lang=js"
import style0 from "./RegisteredAddressesTable.vue?vue&type=style&index=0&id=05fca248&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports